<template lang="pug">
  div(id="form-operator")
    app-header()

    section(class='u-bg-primary')
      div(class='u-flex o-wrapper u-py5 u-flex-wrap u-items-start')
        div(data-aos='fade-right' class='u-white u-7/12@laptop u-6/12@tablet u-12/12')
          div(class='u-8/12@laptop u-10/12@tablet u-px2 u-mx-auto')
            h2(class='u-fz-h0 u-line-1 u-mb3 u-mt4 u-mt0')
              span(class='u-color-secondary u-block') Trabaja con
              span(class='u-white u-block') nosotros

            p(class='u-color-text u-mb0 u-mt0 u-fz-h4 u-mb4') Horarios flexibles, un equipo jóven, un gran ambiente y muchas oportunidades

            figure(class='u-m0 u-show@laptop ')
              img(src='/images/car_pavill.png')
        div(data-aos='fade-left' class='u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex')
          input-validate(
            v-model='form.firstname', :rule='rules.firstname' icon='user' placeholder='Nombres', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.lastname', :rule='rules.lastname' placeholder='Apellidos', :validation='toggleValidate'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.dni', :rule='rules.dni' icon='message' placeholder='DNI', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.workExperience', :rule='rules.workExperience' placeholder='Cuéntanos un resumen de tu experiencia laboral', :validation='toggleValidate' type='textarea' rows='4'
            wrapper-class='c-input' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.whyWork', :rule='rules.whyWork' placeholder='¿Por qué deseas trabajar con nosotros?', :validation='toggleValidate'
            wrapper-class='c-input' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          label(class='u-block u-mb2 u-px2 u-mr3 u-12/12 u-color-text u-fw-s-bold') Adjuntar los siguientes requisitos:

          input-validate(
            v-model='form.curriculumvitae' icon='application', :rule='rules.curriculumvitae', :info='infos.curriculumvitae' placeholder='Currículum vitae', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          //- file-validate(type='file' @update='updateFile'
          //-   :rule='rules.x13' icon='application' placeholder='Currículum vitae', :validation='toggleValidate'
          //-   wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          file-validate(type='file' @update='updateFile', :clear='clearForm'
            :rule='rules.photo.extension' icon='photo' placeholder='Foto', :validation='toggleValidate', :info='infos.photo'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          div(class='u-px2 u-12/12')
            button(class='c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2' @click='postForm') Registrarse


    section(class='u-py5 o-wrapper')
      h3(class='u-mt0 u-mb3 u-fz-h1 u-center u-line-1' data-aos='fade-up' )
        span(class='u-color-secondary u-inline-block') Convenios&nbsp;
        span(class='u-inline-block u-fw-light') que te benefician

      p(class='o-container o-wrapper u-center u-mb4' data-aos='fade-up' ) Convenios con empresas privadas y públicas con ubicaciones en paraderos estratégicos en toda la ciudad, trabajamos con la cadena de mercados del Perú Plaza Vea.

      ul(class='u-flex u-flex-wrap u-pl0 u-list-none u-mb0 u-justify-center')
        li(data-aos='fade-up' v-for='(parnert, index) in company.parnerts' class='u-px4 u-mb3', :class="{'u-12/12 u-center u-mb4' : index === 0}")
          a(style='height:60px' class='u-m0 u-block', :href='parnert.link' target='_blank')
            img(:src='parnert.imageUrl', :title='parnert.title' style='max-height:100%')

    section(class='u-pb4 o-wrapper')
      h3(class='u-mt0 u-mb4 u-fz-h1 u-center u-line-1' data-aos='fade-up')
        span(class='u-color-secondary u-inline-block') Paraderos&nbsp;
        span(class='u-inline-block u-fw-light') estratégicos

      ul(class='u-mt0 u-pt3 u-flex u-flex-wrap u-list-none u-mb0 u-pl0 u-justify-center')
        li(v-for='whereabout in whereabouts' class='u-px3 u-mb4 u-4/12@tablet u-12/12 u-px3' data-aos='fade-up')
          figure(class='u-mb0 u-mt0 u-mx2 u-br16 u-overflow-hidden')
            img(:src='whereabout.imageUrl')
          p(class='u-mb2 u-px2 u-center u-color-tertiary u-fz-h4 u-fw-light') {{whereabout.name}}
          p(class='u-px2 u-mt0 u-mb3 u-center u-color-dark') {{whereabout.address}}

    section(class='o-wrapper u-center u-pb5')
      h3(class='u-color-primary u-fz-h3 u-mt0 u-mb3' data-aos='fade-up') ¿Te interesa?
      a(class='c-btn--primary u-px5 u-fw-bold u-inline-flex u-items-center' href="#"  v-scroll-to="'#form-operator'" data-aos='fade-up') Empieza hoy

    app-footer
    loading(message='Enviando' v-if='isLoading')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false' message='Nos pondremos en contacto con usted.')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Validator from 'validatorjs'

  export default {
    name: 'OperatorScreen',
    data () {
      return {
        isShowModalConfirm: false,
        isShowModalError: false,
        toggleValidate: false,
        clearForm: false,
        formValidate: false,
        isLoading: false,
        form: {
          firstname: '',
          lastname: '',
          dni: '',
          workExperience: '',
          whyWork: '',
          photo: {
            base64: '',
            extension: ''
          },
          curriculumvitae: ''
        },
        rules: {
          firstname: 'required|name',
          lastname: 'required|name',
          dni: 'required',
          workExperience: 'required',
          whyWork: 'required',
          photo: {
            extension: 'required'
          },
          curriculumvitae: 'required|url'
        },
        infos: {
          curriculumvitae: '<span class="u-block">Insertar o copiar una URL del documento</span><span class="u-block">Ejm: <strong>www.drive.google.com/midocumento</strong></span>',
          photo: 'Tamaño máximo del archivo <strong>2MB</strong>'
        },
        whereabouts: []
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`${window.API_URL}/operators`, this.form)
            .then((response) => {
              this.isLoading = false
              this.isShowModalConfirm = true
              this.form = {
                firstname: '',
                lastname: '',
                dni: '',
                workExperience: '',
                whyWork: '',
                photo: {
                  base64: '',
                  extension: ''
                },
                curriculumvitae: ''
              }
              this.clearForm = true
            })
            .catch(({response}) => {
              this.isLoading = false
              this.isShowModalError = true
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      },

      updateFile (image) {
        this.form.photo = image
      },

      getWhereabouts () {
        axios.get(`${window.API_URL}/whereabouts`)
          .then(({data}) => {
            this.whereabouts = data.data
          })
      }
    },

    created () {
      this.getWhereabouts()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Operator/components/OperatorScreen.vue